import { Box, Typography, styled } from "@mui/material";

export const PageContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  font-family: Inter, sans-serif;
`;

export const NumberText = styled(Typography)`
  font-size: 30px;
  font-weight: 700;
  text-align: left;
`;

export const DescriptionText = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  text-align: left;
`;
